import produce from 'immer';
import {
  STARTER_PACK_EVENT_CREATE_REQUEST,
  STARTER_PACK_EVENT_INFO_DELETE_REQUEST,
  STARTER_PACK_EVENT_INFO_DETAILS,
  STARTER_PACK_EVENT_INFO_DETAILS_REQUEST,
  STARTER_PACK_EVENT_INFO_UPDATE_REQUEST,
  STARTER_PACK_EVENT_LIST,
  STARTER_PACK_EVENT_LIST_REQUEST,
  STARTER_PACK_EVENT_PAGE_RESET,
  STARTER_PACK_EVENT_RESPONSE_MESSAGE,
  SET_STARTER_PACK_EVENT_PAGINATION,
  SET_TOTAL_COUNT, STARTER_PACK_EVENT_DEPOSIT_REQUEST, STARTER_PACK_EVENT_ADD_BUDGET,
} from '../../constants/event/starterPackEventConstatns';

const initialState = {
  list: [],
  resultCode: null,
  message: null,
  page: 1,
  pageLength: 10,
  totalCount: 0,
  searchString: '',
  searchType: '',
  scheduleInfo: [],
  logInfo: [],
};

const starterPackReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case STARTER_PACK_EVENT_LIST_REQUEST:
      break;
    case STARTER_PACK_EVENT_LIST:
      draft.list = action.list;
      break;
    case STARTER_PACK_EVENT_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      draft.message = action.message;
      break;
    case STARTER_PACK_EVENT_CREATE_REQUEST:
      break;
    case STARTER_PACK_EVENT_INFO_DETAILS_REQUEST:
      break;
    case STARTER_PACK_EVENT_INFO_DETAILS:
      draft.scheduleInfo = action.scheduleInfo;
      draft.logInfo = action.logInfo;
      break;
    case STARTER_PACK_EVENT_INFO_UPDATE_REQUEST:
      break;
    case STARTER_PACK_EVENT_INFO_DELETE_REQUEST:
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_STARTER_PACK_EVENT_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.searchType = action.searchType;
      draft.searchString = action.searchString;
      break;
    case STARTER_PACK_EVENT_PAGE_RESET:
      draft.page = 1;
      break;
    case STARTER_PACK_EVENT_DEPOSIT_REQUEST:
      break;
    case STARTER_PACK_EVENT_ADD_BUDGET:
      break;
    default:
      break;
  }
});

export default starterPackReducer;
